import { ProdutoFacade } from './../../../shared/facades/produto.facade';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BannerPopupService} from '../../../shared/services/bannerPopup.service';

@Component({
    selector: 'ui-modal-banner',
    templateUrl: './modal-banner.component.html',
    styleUrls: ['./modal-banner.component.scss'],
    standalone: false
})
export class ModalBannerComponent implements OnInit {
  @Input('p-src') src: string;
  @Input('p-alt') alt: string;
  @Input('p-isOpen') isOpen: boolean;
  @Output('p-isClose') isClose = new EventEmitter();

  constructor(
    private router: Router,
    private produtoFacade: ProdutoFacade,
    public bannerPopupService: BannerPopupService
  ) { }

  ngOnInit() {}

  closeModal() {
    this.bannerPopupService.close();
  }

  onClick() {
    if(this.bannerPopupService.onClickCallback)
      this.bannerPopupService.onClickCallback();
  }
}